import { css } from '@emotion/react';

export const packageCardLinkStyles = css`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;
